/**
 * Theme Colors Utility
 * Reads color values from environment variables (.env.development)
 */

export const themeColors = {
  // Primary and Secondary Colors from environment
  primaryColor: process.env.REACT_APP_PRIMARY_COLOR || '#0f538d',
  secondaryColor: process.env.REACT_APP_SECONDARY_COLOR || '#ffa726',
  
  // Additional color utilities
  blackColor: process.env.REACT_APP_BLACK_COLOR || '#282828',
  greyColor: process.env.REACT_APP_GREY_COLOR || '#969696',
  mediumGreyColor: process.env.REACT_APP_MEDIUM_GREY_COLOR || '#cdcdcd',
  lightGreyColor: process.env.REACT_APP_LIGHT_GREY_COLOR || '#F9FAFC',
  redColor: process.env.REACT_APP_RED_COLOR || '#ff1717',
  greenColor: process.env.REACT_APP_GREEN_COLOR || '#2fab73',
  blueColor: process.env.REACT_APP_BLUE_COLOR || '#0323c7',
  yellowColor: process.env.REACT_APP_YELLOW_COLOR || '#ffe84a',
  violetColor: process.env.REACT_APP_VIOLET_COLOR || '#6665DD',
  whiteColor: process.env.REACT_APP_WHITE_COLOR || '#ffffff',
  lightBlueColor: process.env.REACT_APP_LIGHT_BLUE_COLOR || '#EDFBF9',
  skyBlueColor: process.env.REACT_APP_SKY_BLUE_COLOR || '#EFEEFD',
  lightPinkColor: process.env.REACT_APP_LIGHT_PINK_COLOR || '#FFF1D2',
  lightOrangeColor: process.env.REACT_APP_LIGHT_ORANGE_COLOR || '#ffa72633',
  darkRedColor: process.env.REACT_APP_DARK_RED_COLOR || '#BE0909',
  lightGreenColor: process.env.REACT_APP_LIGHT_GREEN_COLOR || '#34D19E',
  lightBlackColor: process.env.REACT_APP_LIGHT_BLACK_COLOR || '#414D55',
};

export default themeColors;
